/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Fehler beim Abbrechen der Twitch-Integration',
    ERROR: 'Fehler',
    FETCH_DATA: 'Daten abrufen'
  },
  HEADER: {
    DATE: 'Datum',
    MESSAGE: 'Nachricht',
    NAME: 'Name',
    ORDER_CODE: 'Bestellcode',
    ORDER_VALUE: 'Wert'
  },
  LABEL: {
    ACTIVE_SINCE: 'Aktiv seit',
    INTEGRATIONS: 'Integrationen',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Twitch-Berechtigungen',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis ist berechtigt, während Streams auf Twitch Alerts zu erstellen.',
    TWITCH_INFORMATION:
      'Prozis bittet um Berechtigung, während Streams auf Twitch Alerts erstellen zu dürfen.',
    TWITCH_INTEGRATION: 'Twitch-Integration'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Twitch-Integration abgebrochen',
    SUCCESS: 'Erfolg'
  },
  TOOLTIP: {
    ORDER_CODE: 'Bestellcode'
  }
};
